import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { ErrorStateMatcher } from '@angular/material/core';
import { DirtyInvalidErrorStateMatcher } from '@examdojo/angular/forms';
import { ButtonComponent } from '@examdojo/core/button';
import { IconComponent } from '@examdojo/core/icon';
import { ComponentSize } from '@examdojo/core/model';

const TIME_OPTIONS: string[] = Array.from({ length: 48 }, (_, i) => {
  const hours = Math.floor(i / 2);
  const minutes = i % 2 === 0 ? '00' : '30';
  return `${String(hours).padStart(2, '0')}:${minutes}`;
});

@Component({
  selector: 'dojo-time-picker-button',
  imports: [ButtonComponent, IconComponent, MatMenuModule, ReactiveFormsModule],
  templateUrl: './time-picker-button.component.html',
  styleUrl: './time-picker-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimePickerButtonComponent {

  readonly control = input.required<FormControl<string | null>>();
  readonly placeholder = input.required<string>();
  readonly size = input<ComponentSize>('s');
  readonly errorStateMatcher = input<ErrorStateMatcher>(new DirtyInvalidErrorStateMatcher());

  readonly timeOptions = TIME_OPTIONS;

  readonly hasError = computed(() => this.errorStateMatcher().isErrorState(this.control(), null));

  selectTime(time: string): void {
    this.control().setValue(time);
    this.control().markAsDirty();
  }
}
